import { render } from "./i-trash.vue?vue&type=template&id=313587ef"
import script from "./i-trash.vue?vue&type=script&lang=js"
export * from "./i-trash.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__